import { frontendURL } from '../../../../helper/URLHelper';
import { LABEL_PERMISSIONS } from 'dashboard/constants/permissions';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels-legacy'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'labels_legacy_wrapper',
          meta: {
            permissions: LABEL_PERMISSIONS,
          },
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'labels_legacy_list',
          meta: {
            permissions: LABEL_PERMISSIONS,
          },
          component: Index,
        },
      ],
    },
  ],
};
